"use client";

import Icon from "@/components/ui/Icon";
import { Typography } from "@/components/ui/typography";
import { cn } from "@/lib/utils";
import { memo } from "react";

type OrderCardListProps = {
  className?: string;
  items?: string[];
} & React.ComponentProps<"ul">;

export const OrderCardList = memo(
  ({ className, items }: OrderCardListProps) => {
    return (
      <ul
        className={cn(
          "grid grid-cols-1 gap-2 flex-auto min-w-0",
          className
        )}
      >
        {items?.map((text, i) => (
          <li key={i}>
            <Typography
              variant="labelFixedMd"
              className="flex items-center"
              asChild
            >
              <div>
                <Icon
                  id="icon-check-in-circle_32"
                  className="w-8 h-8 shrink-0 mr-2 text-blue-500"
                />
                <p>{text}</p>
              </div>
            </Typography>
          </li>
        ))}
      </ul>
    );
  }
);

export default OrderCardList;
